import Box from "@mui/material/Box";
import {FC, useMemo} from "react";
import {SxProps} from "@mui/system";
import {Theme, useTheme} from "@mui/material/styles";
import {alpha} from "@mui/material";

interface IProps {
    content: string | number
    max?: number
    sx?: SxProps<Theme>
}

const Badge: FC<IProps> = (props) => {
    const theme = useTheme()
    const getContent = useMemo(() => {
        if (typeof props.content === "number" && props.max && props.content > props.max) {
            return `${props.max}+`
        }
        return props.content
    }, [props.content, props.max])
    return (
        <Box sx={{
            ...props.sx,
            p: "0 6px",
            backgroundColor: theme.palette.primary.main,
            whiteSpace: 'nowrap',
            color: alpha(theme.palette.secondary.main, .8),
            fontSize: '0.75rem',
            borderRadius: '10px'
        }}>
            {getContent}
        </Box>
    )
}

export default Badge